export const currencyFormat = amount => {
    const amountParse = parseFloat(amount);
    return `$${amountParse.toFixed(2)}`;
};
